import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useIsInActiveTrial } from '../../../hooks/useIsInActiveTrial';
import { useAppSelector } from '../../../reducers';
import { authSelector, isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { productsFromProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { getUniqueInterestedUsers } from '../../../utils/featureInterestUtils';
import LimitUsageSection from '../../suite-starter-page/limit-usage/LimitUsageSection';
import FeatureInterestSection from './FeatureInterestSection';
import TeamMemberFeatureInterest from './TeamMemberFeatureInterest';
const VerticalLineBreak = styled.div.withConfig({
  displayName: "FeatureInterestAndLimitUsageSection__VerticalLineBreak",
  componentId: "lzd4ik-0"
})(["width:1px;background-color:", ";margin:0 50px;"], GREAT_WHITE);

const FeatureInterestAndLimitUsageSection = ({
  limitUsages,
  featureInterest
}) => {
  const ownedProducts = useSelector(state => {
    const hasPricingAndPurchasingSucceeded = hasPricingAndPurchasingSucceededSelector(state);
    if (!hasPricingAndPurchasingSucceeded) return [];
    return productsFromProductInventorySelector(state);
  });
  const isInTrial = useIsInActiveTrial();
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isFreePortal = isAppAuth && ownedProducts && ownedProducts.length <= 0;
  const isNonTrialFreePortal = isFreePortal && !isInTrial;
  const {
    user
  } = useSelector(authSelector);
  const currentUserEmail = user.email;
  const uniqueInterestedUsers = getUniqueInterestedUsers(featureInterest, currentUserEmail);
  const showLimitUsages = !!limitUsages.length && isNonTrialFreePortal;
  const showFeatureInterest = !!featureInterest.length && isNonTrialFreePortal;

  if (showFeatureInterest && showLimitUsages) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        width: '100%'
      },
      className: "m-top-6",
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(TeamMemberFeatureInterest, {
          interestedUsers: uniqueInterestedUsers
        }), /*#__PURE__*/_jsxs("div", {
          className: "display-flex",
          children: [/*#__PURE__*/_jsx(LimitUsageSection, {
            limitUsages: limitUsages
          }), /*#__PURE__*/_jsx(VerticalLineBreak, {}), /*#__PURE__*/_jsx(FeatureInterestSection, {
            featureInterest: featureInterest
          })]
        })]
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      })]
    });
  }

  if (showLimitUsages || showFeatureInterest) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        width: '100%'
      },
      className: "m-top-6",
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      }), /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(TeamMemberFeatureInterest, {
          interestedUsers: uniqueInterestedUsers,
          width: "100%"
        }), /*#__PURE__*/_jsxs("div", {
          className: "display-flex justify-center",
          style: {
            width: '100%'
          },
          children: [showLimitUsages && /*#__PURE__*/_jsx(LimitUsageSection, {
            limitUsages: limitUsages,
            width: "100%"
          }), showFeatureInterest && /*#__PURE__*/_jsx(FeatureInterestSection, {
            featureInterest: featureInterest
          })]
        })]
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-large"
      })]
    });
  }

  return null;
};

export default FeatureInterestAndLimitUsageSection;